//App action types
export const INIT_START = "INIT_START";
export const INIT_SUCCESS = "INIT_SUCCESS";
export const INIT_FAIL = "INIT_FAIL";
export const APP_ERROR = "APP_ERROR";
export const APP_ADD_MESSAGE = "APP_ADD_MESSAGE";
export const APP_REMOVE_DIALOG = "APP_REMOVE_DIALOG";
export const APP_MODULE_SUCCESS = "APP_MODULE_SUCCESS";
export const APP_MODULE_ERROR = "APP_MODULE_ERROR";

//Auth action types
export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const SET_AUTH_REDIRECT_PATH = "SET_AUTH_REDIRECT_PATH";
export const AUTH_SESSION_LOGIN_START = "AUTH_SESSION_LOGIN_START"
export const AUTH_SESSION_LOGIN_SUCCESS = "AUTH_SESSION_LOGIN_SUCCESS";
export const AUTH_SESSION_LOGIN_FAIL = "AUTH_SESSION_LOGIN_FAIL";
export const AUTH_SWITCH_GROUP_START = "AUTH_SWITCH_GROUP_START";
export const AUTH_SWITCH_GROUP_SUCCESS = "AUTH_SWITCH_GROUP_SUCCESS";
export const AUTH_SWITCH_GROUP_FAIL = "AUTH_SWITCH_GROUP_FAIL";
export const AUTH_LOGOUT_START = "AUTH_LOGOUT_START";
export const AUTH_LOGOUT_SUCCESS = "AUTH_LOGOUT_SUCCESS";
export const AUTH_LOGOUT_FAIL = "AUTH_LOGOUT_FAIL";

//UI action types
export const UI_RESTORE = "UI_RESTORE";
export const UI_LEFT_SIDEBAR_OPENED = "UI_LEFT_SIDEBAR_OPENED";
export const UI_LEFT_SIDEBAR_CLOSED = "UI_LEFT_SIDEBAR_CLOSED";
export const UI_LEFT_SIDEBAR_OPENING = "UI_LEFT_SIDEBAR_OPENING";
export const UI_LEFT_SIDEBAR_CLOSING = "UI_LEFT_SIDEBAR_CLOSING";
export const UI_CHANGE_LANGUAGE = "UI_CHANGE_LANGUAGE";
export const UI_TOGGLE_FILTER = "UI_TOGGLE_FILTER";
export const UI_METADATA_OPENED = "UI_METADATA_OPENED";
export const UI_METADATA_CLOSED = "UI_METADATA_CLOSED";

export const UI_PANEL_OPEN = "UI_PANEL_OPEN";
export const UI_PANEL_CLOSE = "UI_PANEL_CLOSE";

export const UI_SET_CLIPLIST_VIEW_MODE = "UI_SET_CLIPLIST_VIEW_MODE";
export const UI_UPLOAD_OPENED = "UI_UPLOAD_OPENED";
export const UI_UPLOAD_CLOSED = "UI_UPLOAD_CLOSED";
export const UI_UPLOAD_OPENING = "UI_UPLOAD_OPENING";
export const UI_UPLOAD_ADD_DRAGDROP = "UI_UPLOAD_ADD_DRAGDROP";
export const LOAD_UI_CONFIG_START = "LOAD_UI_CONFIG_START";
export const LOAD_UI_CONFIG_SUCCESS = "LOAD_UI_CONFIG_SUCCESS";
export const LOAD_UI_CONFIG_FAIL = "LOAD_UI_CONFIG_FAIL";

//WebApi
/*export const WEBAPI_POSTMESAGE_START = 'WEBAPI_POSTMESAGE_START';
export const WEBAPI_POSTMESSAGE_SUCCESS = 'WEBAPI_POSTMESSAGE_SUCCESS';
export const WEBAPI_POSTMESSAGE_FAIL = 'WEBAPI_POSTMESSAGE_FAIL';*/
export const UI_POST_WEBAPIMESSAGE = "UI_POST_WEBAPIMESSAGE";
export const UI_DELETE_WEBAPIMESSAGE = "UI_DELETE_WEBAPIMESSAGE";
export const UI_POST_WEBAPIMEDIA = "UI_POST_WEBAPIMEDIA";
export const UI_SAVE_WEBAPI_FILEPATH = "UI_SAVE_WEBAPI_FILEPATH";

//TagsTree
export const UI_SAVE_SELECTEDTAGS = "UI_SAVE_SELECTEDTAGS";
export const UI_SAVE_SELECTEDMODELS = "UI_SAVE_SELECTEDMODELS";
export const UI_ADD_APITAGS = "UI_ADD_APITAGS";
export const UI_ADD_APIMODELS = "UI_ADD_APIMODELS";

//AppsConfig
export const UI_ADD_APIAPPSCONFIG = "UI_ADD_APIAPPSCONFIG";
export const UI_ADD_APIUPLOADCONFIG = "UI_ADD_APIUPLOADCONFIG";
export const UI_ADD_APIEXPERTSEARCHCONFIG = "UI_ADD_APIEXPERTSEARCHCONFIG";

//TempFormConfig
export const UI_ADD_TEMPCONFIG = "UI_ADD_TEMPCONFIG";
export const UI_TEMP_SAVEDATA = "UI_TEMP_SAVEDATA";
export const UI_TEMP_OPENED = "UI_TEMP_OPENED";
export const UI_TEMP_CLOSED = "UI_TEMP_CLOSED";

export const UI_EXPERT_SEARCH_OPENED = "UI_EXPERT_SEARCH_OPENED";
export const UI_EXPERT_SEARCH_CLOSED = "UI_EXPERT_SEARCH_CLOSED";
export const UI_EXPERT_SEARCH_SAVEDATA = "UI_EXPERT_SEARCH_SAVEDATA";
export const UI_EXPERT_SEARCH_SETUPDATA = "UI_EXPERT_SEARCH_SETUPDATA";
//Select Language
export const UI_SELECT_LANGUAGE = "SELECT_LANGUAGE";

//Countries
export const UI_DISPLAY_COUNTRIES = "UI_DISPLAY_COUNTRIES";
export const UI_SELECT_COUNTRIES = "UI_SELECT_COUNTRIES";
export const UI_REMOVE_COUNTRIES = "UI_REMOVE_COUNTRIES";
export const UI_REMOVE_ALLCOUNTRIES = "UI_REMOVE_ALLCOUNTRIES";

//Sortorder
export const SET_SORTORDER = "SET_SORTORDER";

//Home action types
export const HOME_FETCH_START = "HOME_FETCH_START";
export const HOME_FETCH_SUCCESS = "HOME_FETCH_SUCCESS";
export const HOME_FETCH_ERROR = "HOME_FETCH_ERROR";

//Projects action types
export const SELECT_PROJECT = "SELECT_PROJECT";
export const ADD_CLIP_TO_PROJECT_START = "ADD_CLIP_TO_PROJECT_START";
export const ADD_CLIP_TO_PROJECT_FAIL = "ADD_CLIP_TO_PROJECT_FAIL";
export const ADD_CLIP_TO_PROJECT_SUCCESS = "ADD_CLIP_TO_PROJECT_SUCCESS";
export const ADD_CLIPS_TO_PROJECT_START = "ADD_CLIPS_TO_PROJECT_START";
export const ADD_CLIPS_TO_PROJECT_FAIL = "ADD_CLIPS_TO_PROJECT_FAIL";
export const ADD_CLIPS_TO_PROJECT_SUCCESS = "ADD_CLIPS_TO_PROJECT_SUCCESS";
export const REMOVE_CLIP_FROM_PROJECT_START = "REMOVE_CLIP_FROM_PROJECT_START";
export const REMOVE_CLIP_FROM_PROJECT_FAIL = "REMOVE_CLIP_FROM_PROJECT_FAIL";
export const REMOVE_CLIP_FROM_PROJECT_SUCCESS =
  "REMOVE_CLIP_FROM_PROJECT_SUCCESS";
export const REMOVE_CLIPS_FROM_PROJECT_START =
  "REMOVE_CLIPS_FROM_PROJECT_START";
export const REMOVE_CLIPS_FROM_PROJECT_FAIL = "REMOVE_CLIPS_FROM_PROJECT_FAIL";
export const REMOVE_CLIPS_FROM_PROJECT_SUCCESS =
  "REMOVE_CLIPS_FROM_PROJECT_SUCCESS";
export const GET_PROJECTS_START = "GET_PROJECTS_START";
export const GET_PROJECTS_SUCCESS = "GET_PROJECTS_SUCCESS";
export const GET_PROJECTS_FAIL = "GET_PROJECTS_FAIL";
export const GET_PROJECT_CLIPS_START = "GET_PROJECT_CLIPS_START";
export const GET_PROJECT_CLIPS_SUCCESS = "GET_PROJECT_CLIPS_SUCCESS";
export const GET_PROJECT_CLIPS_FAIL = "GET_PROJECT_CLIPS_FAIL";
export const SET_ACTIVE_PROJECT = "SET_ACTIVE_PROJECT";
export const NEW_PROJECT_START = "NEW_PROJECT_START";
export const NEW_PROJECT_FAIL = "NEW_PROJECT_START";
export const NEW_PROJECT_SUCCESS = "NEW_PROJECT_START";
export const DELETE_PROJECT_SUCCESS = "DELETE_PROJECT_SUCCESS";
export const DELETE_PROJECT_FAIL = "DELETE_PROJECT_FAIL";
export const COPY_PROJECT_START = "COPY_PROJECT_START";
export const COPY_PROJECT_SUCCESS = "COPY_PROJECT_SUCCESS";
export const COPY_PROJECT_FAIL = "COPY_PROJECT_FAIL";
export const PROJECT_UPDATE_RECEIVED = "PROJECT_UPDATE_RECEIVED";

export const GET_DELETED_PROJECTS_START = "GET_DELETED_PROJECTS_START";
export const GET_DELETED_PROJECTS_SUCCESS = "GET_DELETED_PROJECTS_SUCCESS";
export const GET_DELETED_PROJECTS_FAIL = "GET_DELETED_PROJECTS_FAIL";

// ProjectTree
export const GET_PROJECT_TREE_START = "GET_PROJECT_TREE_START";
export const GET_PROJECT_TREE_SUCCESS = "GET_PROJECT_TREE_SUCCESS";
export const GET_PROJECT_TREE_FAIL = "GET_PROJECT_TREE_FAIL";
export const PROJECT_CHILD_ADD_START = "PROJECT_CHILD_ADD_START";
export const PROJECT_CHILD_ADD_SUCCESS = "PROJECT_CHILD_ADD_SUCCESS";
export const PROJECT_CHILD_ADD_FAIL = "PROJECT_CHILD_ADD_FAIL";

// SeriesTree
export const SERIES_LOAD_START = "SERIES_LOAD_START";
export const SERIES_LOAD_SUCCESS = "SERIES_LOAD_SUCCESS";
export const SERIES_LOAD_FAIL = "SERIES_LOAD_FAIL";
export const SERIES_SET_ACTIVE = "SERIES_SET_ACTIVE";
export const SERIES_GET_CLIPS_START = "SERIES_GET_CLIPS_START";
export const SERIES_GET_CLIPS_SUCCESS = "SERIES_GET_CLIPS_SUCCESS";
export const SERIES_GET_CLIPS_FAIL = "SERIES_GET_CLIPS_FAIL";

//Actions action types
export const GET_FLOWACTIONS_START = "GET_FLOWACTIONS_START";
export const GET_FLOWACTIONS_SUCCESS = "GET_FLOWACTIONS_SUCCESS";
export const GET_FLOWACTIONS_FAIL = "GET_FLOWACTIONS_FAIL";

// Distribution Tree
export const GET_DISTRIBUTION_TREE_START = "GET_DISTRIBUTION_TREE_START";
export const GET_DISTRIBUTION_TREE_SUCCESS = "GET_DISTRIBUTION_TREE_SUCCESS";
export const GET_DISTRIBUTION_TREE_FAIL = "GET_DISTRIBUTION_TREE_FAIL";
export const GET_DISTRIBUTION_BY_DIST_START = "GET_DISTRIBUTION_BY_DIST_START";
export const GET_DISTRIBUTION_BY_DIST_SUCCESS = "GET_DISTRIBUTION_BY_DIST_SUCCESS";
export const GET_DISTRIBUTION_BY_DIST_FAIL = "GET_DISTRIBUTION_BY_DIST_FAIL";
export const DISTRIBUTION_CHILD_ADD_START = "DISTRIBUTION_CHILD_ADD_START";
export const DISTRIBUTION_CHILD_ADD_SUCCESS = "DISTRIBUTION_CHILD_ADD_SUCCESS";
export const DISTRIBUTION_CHILD_ADD_FAIL = "DISTRIBUTION_CHILD_ADD_FAIL";
export const DISTRIBUTION_REMOVE_CLIPS_START = "DISTRIBUTION_REMOVE_CLIPS_START";
export const DISTRIBUTION_REMOVE_CLIPS_SUCCESS = "DISTRIBUTION_REMOVE_CLIPS_SUCCESS";
export const DISTRIBUTION_REMOVE_CLIPS_FAIL = "DISTRIBUTION_REMOVE_CLIPS_FAIL";

// Newsroom Tree
export const GET_NEWSROOM_TREE_START = "GET_NEWSROOM_TREE_START";
export const GET_NEWSROOM_TREE_SUCCESS = "GET_NEWSROOM_TREE_SUCCESS";
export const GET_NEWSROOM_TREE_FAIL = "GET_NEWSROOM_TREE_FAIL";
export const GET_NEWSROOM_BY_NEWSROOM_START = "GET_NEWSROOM_BY_NEWSROOM_START";
export const GET_NEWSROOM_BY_NEWSROOM_SUCCESS = "GET_NEWSROOM_BY_NEWSROOM_SUCCESS";
export const GET_NEWSROOM_BY_NEWSROOM_FAIL = "GET_NEWSROOM_BY_NEWSROOM_FAIL";
export const NEWSROOM_CHILD_ADD_START = "NEWSROOM_CHILD_ADD_START";
export const NEWSROOM_CHILD_ADD_SUCCESS = "NEWSROOM_CHILD_ADD_SUCCESS";
export const NEWSROOM_CHILD_ADD_FAIL = "NEWSROOM_CHILD_ADD_FAIL";
export const NEWSROOM_REMOVE_CLIPS_START = "NEWSROOM_REMOVE_CLIPS_START";
export const NEWSROOM_REMOVE_CLIPS_SUCCESS = "NEWSROOM_REMOVE_CLIPS_SUCCESS";
export const NEWSROOM_REMOVE_CLIPS_FAIL = "NEWSROOM_REMOVE_CLIPS_FAIL";
export const NEWSROOM_SET_ACTIVE = "NEWSROOM_SET_ACTIVE";
export const NEW_NEWSROOM_START = "NEW_NEWSROOM_START";
export const NEW_NEWSROOM_SUCCESS = "NEW_NEWSROOM_SUCCESS";
export const NEW_NEWSROOM_FAIL = "NEW_NEWSROOM_FAIL";
export const DELETE_NEWSROOM_START = "DELETE_NEWSROOM_START";
export const DELETE_NEWSROOM_SUCCESS = "DELETE_NEWSROOM_SUCCESS";
export const DELETE_NEWSROOM_FAIL = "DELETE_NEWSROOM_FAIL";

//Distributions action types
export const GET_DISTRIBUTIONS_START = "GET_DISTRIBUTIONS_START";
export const GET_DISTRIBUTIONS_SUCCESS = "GET_DISTRIBUTIONS_SUCCESS";
export const GET_DISTRIBUTIONS_FAIL = "GET_DISTRIBUTIONS_FAIL";
export const SET_CURRENT_DISTRIBUTION = "SET_CURRENT_DISTRIBUTION";
export const SET_ACTIVE_DISTRIBUTION = "SET_ACTIVE_DISTRIBUTION";
export const TWITTER_GET_TWEETS = "TWITTER_GET_TWEETS";
export const TWITTER_GET_TWEETS_SUCCESS = "TWITTER_GET_TWEETS_SUCCESS";

//Rooms action types
export const SELECT_ROOM = "SELECT_ROOM";
export const ADD_CLIP_TO_ROOM_START = "ADD_CLIP_TO_ROOM_START";
export const ADD_CLIP_TO_ROOM_FAIL = "ADD_CLIP_TO_ROOM_FAIL";
export const ADD_CLIP_TO_ROOM_SUCCESS = "ADD_CLIP_TO_ROOM_SUCCESS";
export const REMOVE_CLIP_FROM_ROOM_START = "REMOVE_CLIP_FROM_ROOM_START";
export const REMOVE_CLIP_FROM_ROOM_FAIL = "REMOVE_CLIP_FROM_ROOM_FAIL";
export const REMOVE_CLIP_FROM_ROOM_SUCCESS = "REMOVE_CLIP_FROM_ROOM_SUCCESS";
export const REMOVE_CLIPS_FROM_ROOM_START = "REMOVE_CLIPS_FROM_ROOM_START";
export const REMOVE_CLIPS_FROM_ROOM_FAIL = "REMOVE_CLIPS_FROM_ROOM_FAIL";
export const REMOVE_CLIPS_FROM_ROOM_SUCCESS = "REMOVE_CLIPS_FROM_ROOM_SUCCESS";
export const GET_ROOMS_START = "GET_ROOMS_START";
export const GET_ROOMS_SUCCESS = "GET_ROOMS_SUCCESS";
export const GET_ROOMS_FAIL = "GET_ROOMS_FAIL";
export const GET_ROOM_CLIPS_START = "GET_ROOM_CLIPS_START";
export const GET_ROOM_CLIPS_SUCCESS = "GET_ROOM_CLIPS_SUCCESS";
export const GET_ROOM_CLIPS_FAIL = "GET_ROOM_CLIPS_FAIL";
export const SET_ACTIVE_ROOM = "SET_ACTIVE_ROOM";
export const NEW_ROOM_START = "NEW_ROOM_START";
export const NEW_ROOM_FAIL = "NEW_ROOM_START";
export const NEW_ROOM_SUCCESS = "NEW_ROOM_START";
export const DELETE_ROOM_SUCCESS = "DELETE_ROOM_SUCCESS";
export const DELETE_ROOM_FAIL = "DELETE_ROOM_FAIL";
export const COPY_ROOM_START = "COPY_ROOM_START";
export const COPY_ROOM_SUCCESS = "COPY_ROOM_SUCCESS";
export const COPY_ROOM_FAIL = "COPY_ROOM_FAIL";
export const ROOM_UPDATE_RECEIVED = "ROOM_UPDATE_RECEIVED";

export const GET_DELETED_ROOMS_START = "GET_DELETED_ROOMS_START";
export const GET_DELETED_ROOMS_SUCCESS = "GET_DELETED_ROOMS_SUCCESS";
export const GET_DELETED_ROOMS_FAIL = "GET_DELETED_ROOMS_FAIL";

export const DUPLICATE_ROOM_START = "DUPLICATE_ROOM_START";
export const DUPLICATE_ROOM_SUCCESS = "DUPLICATE_ROOM_SUCCESS";
export const DUPLICATE_ROOM_FAIL = "DUPLICATE_ROOM_FAIL";

export const ROOM_MAKE_ZIP_START = "ROOM_MAKE_ZIP_START";
export const ROOM_MAKE_ZIP_SUCCESS = "ROOM_MAKE_ZIP_SUCCESS";
export const ROOM_MAKE_ZIP_FAIL = "ROOM_MAKE_ZIP_FAIL";

//ClipList types
export const GET_CLIPLIST_START = "GET_CLIPLIST_START";
export const GET_CLIPLIST_SUCCESS = "GET_CLIPLIST_SUCCESS";
export const GET_CLIPLIST_BY_ID_SUCCESS = "GET_CLIPLIST_BY_ID_SUCCESS";
export const GET_CLIP_BY_ID_SUCCESS = "GET_CLIP_BY_ID_SUCCESS";
export const GET_CLIPLIST_FAIL = "GET_CLIPLIST_FAIL";
export const CLIP_UPDATE_RECEIVED = "CLIP_UPDATE_RECEIVED";
export const CLIPLIST_TOGGLE_FILTER = "CLIPLIST_TOGGLE_FILTER";
export const CLIPLIST_SET_FILTER = "CLIPLIST_SET_FILTER";
export const CLIPLIST_DOWNLOAD_START = "CLIPLIST_DOWNLOAD_START";
export const CLIPLIST_DOWNLOAD_FAIL = "CLIPLIST_DOWNLOAD_FAIL";
export const CLIPLIST_DOWNLOAD_SUCCESS = "CLIPLIST_DOWNLOAD_SUCCESS";
export const CLIPLIST_RESET_DOWNLOAD = "CLIPLIST_RESET_DOWNLOAD";
export const SET_CLIPLIST = "SET_CLIPLIST";
export const ARRANGE_CLIPLIST_START = "ARRANGE_CLIPLIST_START";
export const ARRANGE_CLIPLIST_AND_END = "ARRANGE_CLIPLIST_AND_END";
export const SAVE_ARRANGED_CLIPLIST_START = "SAVE_ARRANGED_CLIPLIST_START";
export const SAVE_ARRANGED_CLIPLIST_SUCCESS = "SAVE_ARRANGED_CLIPLIST_SUCCESS";
export const SAVE_ARRANGED_CLIPLIST_FAIL = "SAVE_ARRANGED_CLIPLIST_FAIL";
export const CLIPLIST_RESTORE_START = "CLIPLIST_RESTORE_START";
export const CLIPLIST_RESTORE_SUCCESS = "CLIPLIST_RESTORE_SUCCESS";
export const CLIPLIST_RESTORE_FAIL = "CLIPLIST_RESTORE_FAIL";
export const CLIPLIST_DELETE_START = "CLIPLIST_DELETE_START";
export const CLIPLIST_DELETE_SUCCESS = "CLIPLIST_DELETE_SUCCESS";
export const CLIPLIST_DELETE_FAIL = "CLIPLIST_DELETE_FAIL";
export const CHECK_TRANSCODING_START = "CHECK_TRANSCODING_START";
export const CHECK_TRANSCODING_END = "CHECK_TRANSCODING_END";
export const CHECK_TRANSCODING_SUCCESS = "CHECK_TRANSCODING_SUCCESS";
export const CLIPLIST_SET_PLAYER_DERIVATIVES = "CLIPLIST_SET_PLAYER_DERIVATIVES";


//Clip action types
export const SELECT_CLIP = "SELECT_CLIP";
export const TICK_CLIP = "TICK_CLIP";
export const UNTICK_CLIP = "UNTICK_CLIP";
export const RESET_TICKED_CLIPS = "RESET_TICKED_CLIPS";
export const CLIP_DRAG_START = "CLIP_DRAG_START";
export const CLIP_DRAG_END = "CLIP_DRAG_END";
export const CLIP_REMOVE_MULTISELECTED = "CLIP_REMOVE_MULTISELECTED";
export const CLIP_ADD_MULTISELECTED = "CLIP_ADD_MULTISELECTED";
export const RESET_MULTISELECTED = "RESET_MULTISELECTED";
export const MASS_EDIT_SELECTED = "MASS_EDIT_SELECTED";
export const RESET_MASS_EDIT_SELECTED = "RESET_MASS_EDIT_SELECTED";

export const CUT_CLIP_START = "CUT_CLIP_START";
export const CUT_CLIP_SUCCESS = "CUT_CLIP_SUCCESS";
export const CUT_CLIP_FAIL = "CUT_CLIP_FAIL";

export const SET_RELATED_CLIP = "SET_RELATED_CLIP";

export const CLIP_GRAB_MAINTHUMB_START = "CLIP_GRAB_MAINTHUMB_START";
export const CLIP_GRAB_MAINTHUMB_SUCCESS = "CLIP_GRAB_MAINTHUMB_SUCCESS";
export const CLIP_GRAB_MAINTHUMB_FAIL = "CLIP_GRAB_MAINTHUMB_FAIL";

//Search action types
export const SEARCH_START = "SEARCH_START";
export const SEARCH_SUCCESS = "SEARCH_SUCCESS";
export const SEARCH_FAIL = "SEARCH_FAIL";
export const SEARCH_NEXT_START = "SEARCH_NEXT_START";
export const SEARCH_NEXT_SUCCESS = "SEARCH_NEXT_SUCCESS";
export const SEARCH_NEXT_FAIL = "SEARCH_NEXT_FAIL";
//LAMTEST BEGIN
export const SEARCH_SET_SORT_DEFAULT = "SEARCH_SET_SORT_DEFAULT";
export const SEARCH_SET_SORTORDER_DEFAULT = "SEARCH_SET_SORTORDER_DEFAULT";
//LAMTEST END

//Save new project types
export const SAVE_NEW_PROJECT = "SAVE_NEW_PROJECT";

//Upload file

export const UPLOAD_FILE = "UPLOAD_FILE";
export const UPLOAD_CANCEL = "UPLOAD_CANCEL";
export const UPLOAD_FILE_TO_ONECLIP = "UPLOAD_FILE_TO_ONECLIP";
export const UPLOAD_FILE_START = "UPLOAD_START";
export const UPLOAD_FILE_SUCCESS = "UPLOAD_FILE_SUCCESS";
export const UPLOAD_FILE_FAIL = "UPLOAD_FILE_FAIL";
export const UPLOAD_FILE_ABORTED = "UPLOAD_FILE_ABORTED";
export const UPLOAD_FILE_PROGRESS = "UPLOAD_FILE_PROGRESS";
export const UPLOAD_SET_STATE = "UPLOAD_SET_STATE";
export const UPLOAD_SAVE_UPLOADEDDATA = "UPLOAD_SAVE_UPLOADEDDATA";

export const UPLOAD_IMPORT_FILE_START = "UPLOAD_IMPORT_FILE_START";
export const UPLOAD_IMPORT_FILE_FAIL = "UPLOAD_IMPORT_FILE_FAIL";
export const UPLOAD_IMPORT_FILE_SUCCESS = "UPLOAD_IMPORT_FILE_SUCCESS";

export const UPLOAD_EDIT_CLIP_START = "UPLOAD_EDIT_CLIP_START";
export const UPLOAD_EDIT_CLIP_FAIL = "UPLOAD_EDIT_CLIP_FAIL";
export const UPLOAD_EDIT_CLIP_SUCCESS = "UPLOAD_EDIT_CLIP_SUCCESS";

export const UPLOAD_PROJECT_ADD_CLIP_START = "UPLOAD_PROJECT_ADD_CLIP_START";
export const UPLOAD_PROJECT_ADD_CLIP_FAIL = "UPLOAD_PROJECT_ADD_CLIP_FAIL";
export const UPLOAD_PROJECT_ADD_CLIP_SUCCESS =
  "UPLOAD_PROJECT_ADD_CLIP_SUCCESS";
export const UPLOAD_ROOM_ADD_CLIP_FAIL = "UPLOAD_ROOM_ADD_CLIP_FAIL";
export const UPLOAD_ROOM_ADD_CLIP_SUCCESS = "UPLOAD_ROOM_ADD_CLIP_SUCCESS";

export const UPLOAD_FORM_STATE = "UPLOAD_FORM_STATE";
export const UPLOAD_UPDATE_METADATA = "UPLOAD_UPDATE_METADATA";


//ExpertSearch
export const EXPERT_SEARCH = "EXPERT_SEARCH_FILE";
export const EXPERT_SEARCH_START = "EXPERT_SEARCH_START";
export const EXPERT_SEARCH_SUCCESS = "EXPERT_SEARCH_SUCCESS";
export const EXPERT_SEARCH_FAIL = "EXPERT_SEARCH_FAIL";

//HOOTSUITE
export const HOOTSUITE_PLUGIN = "HOOTSUITE_PLUGIN";

//CUSTOMDATA
export const CUSTOM_SET_ADDFORM_STATE = "CUSTOM_SET_ADDFORM_STATE";
export const CUSTOM_SET_NEWDATA = "CUSTOM_SET_NEWDATA";
export const CUSTOM_SEND_EMAIL_START = "CUSTOM_SEND_EMAIL_START";
export const CUSTOM_SEND_EMAIL_SUCCESS = "CUSTOM_SEND_EMAIL_SUCCESS";
export const CUSTOM_SAVE_LASTCUSTOMDATA_SUCCESS = "CUSTOM_SAVE_LASTCUSTOMDATA_SUCCESS";
export const CUSTOM_SAVE_CURRENTUSER = "CUSTOM_SAVE_CURRENTUSER";
export const CUSTOM_SET_HISTORY = "CUSTOM_SET_HISTORY";
export const CUSTOM_SET_CURRENTCLIPDATA = "CUSTOM_SET_CURRENTCLIPDATA";
export const CUSTOM_SET_CURRENT_SORTOPTION = "CUSTOM_SET_CURRENT_SORTOPTION";
export const CUSTOM_GET_LAST_SEARCH = "CUSTOM_GET_LAST_SEARCH";
export const CUSTOM_SET_CURRENT_DIALOG = "CUSTOM_SET_CURRENT_DIALOG";
export const CUSTOM_RELOAD_PROJECT = "CUSTOM_RELOAD_PROJECT";
export const CUSTOM_SET_CURRENT_PROJECT = "CUSTOM_SET_CURRENT_PROJECT";
export const CUSTOM_SET_EMPTY_PROJECTS = "CUSTOM_SET_EMPTY_PROJECTS";
export const CUSTOM_SET_DELETED_PROJECTS = "CUSTOM_SET_DELETED_PROJECTS";
export const CUSTOM_SET_UPDATED_PROJECTS = "CUSTOM_SET_UPDATED_PROJECTS";
export const CUSTOM_SET_DELETED_ROOMS = "CUSTOM_SET_DELETED_ROOMS";
export const CUSTOM_GET_CONFIGCLIPINFO_FORAPP = "CUSTOM_GET_CONFIGCLIPINFO_FORAPP";
export const CUSTOM_SET_CURRENT_MAIN_FILTER = "CUSTOM_SET_CURRENT_MAIN_FILTER";
export const CUSTOM_SET_CURRENT_SUB_FILTER = "CUSTOM_SET_CURRENT_SUB_FILTER";
export const CUSTOM_SET_UPLOAD_INFO = "CUSTOM_SET_UPLOAD_INFO";
export const CUSTOM_SET_CURRENT_UPLOAD_COUNT = "CUSTOM_SET_CURRENT_UPLOAD_COUNT";
export const CUSTOM_SET_FULLTEXT_SEARCH_DATA = "CUSTOM_SET_FULLTEXT_SEARCH_DATA";
export const CUSTOM_SET_BYFIEDS_SEARCH_DATA = "CUSTOM_SET_BYFIEDS_SEARCH_DATA";
export const CUSTOM_SET_LAST_SEARCH_TYPE = "CUSTOM_SET_LAST_SEARCH_TYPE";
export const CUSTOM_SET_SEARCH_INFO = "CUSTOM_SET_SEARCH_INFO";
export const CUSTOM_TOGGLE_POPUP_HIDDEN = "CUSTOM_TOGGLE_POPUP_HIDDEN";
export const CUSTOM_GOOGLE_SIGN_IN = "CUSTOM_GOOGLE_SIGN_IN";
export const CUSTOM_GET_APP_DATA = "CUSTOM_GET_APP_DATA";
export const CUSTOM_GET_APP_DATA_START = "CUSTOM_GET_APP_DATA_START";
export const CUSTOM_GET_APP_DATA_SUCCESS = "CUSTOM_GET_APP_DATA_SUCCESS";
export const CUSTOM_CREATE_NEW_ENTRY_SUCCESS = "CUSTOM_CREATE_NEW_ENTRY_SUCCESS";
export const CUSTOM_SET_INITIAL_STATE = "CUSTOM_SET_INITIAL_STATE";
export const CUSTOM_CREATE_NEW_ENTRY_FAIL = "CUSTOM_CREATE_NEW_ENTRY_FAIL";
export const CUSTOM_GET_UICONFIG_FORAPP = "CUSTOM_GET_UICONFIG_FORAPP";
export const CUSTOM_MW_LOGOUT = "CUSTOM_MW_LOGOUT";
export const CUSTOM_CATCH_APP_ERRORS = "CUSTOM_CATCH_APP_ERRORS";
export const CUSTOM_SET_REPORTS_DATA = "CUSTOM_SET_REPORTS_DATA";
export const CUSTOM_GET_FLEX_APP_CONFIG = "CUSTOM_GET_FLEX_APP_CONFIG";
//Save new profile types
export const SAVE_NEW_PROFILE = "SAVE_NEW_PROFILE";

export const PROFILE_SAVE_USER = "PROFILE_SAVE_USER";
export const PROFILE_SAVE_USER_START = "PROFILE_SAVE_START";
export const PROFILE_SAVE_USER_SUCCESS = "PROFILE_SAVE_SUCCESS";
export const PROFILE_SAVE_USER_FAIL = "PROFILE_SAVE_FAIL";

export const PROFILE_GET_USER = "PROFILE_GET_USER";
export const PROFILE_GET_USER_START = "PROFILE_GET_USER_START";
export const PROFILE_GET_USER_SUCCESS = "PROFILE_GET_USER_SUCCESS";
export const PROFILE_GET_USER_FAIL = "PROFILE_GET_USER_FAIL";

export const PROFILE_EDIT_USER = "PROFILE_EDIT_USER";
export const PROFILE_EDIT_USER_START = "PROFILE_EDIT_USER_START";
export const PROFILE_EDIT_USER_SUCCESS = "PROFILE_EDIT_USER_SUCCESS";
export const PROFILE_EDIT_USER_FAIL = "PROFILE_EDIT_USER_FAIL";

export const PROFILE_RESET_ERROR = "PROFILE_RESET_ERROR";


//Metadata types
export const UPDATE_METADATA_CLIP_START = "UPDATE_METADATA_CLIP_START";
export const UPDATE_METADATA_CLIP_SUCCESS = "UPDATE_METADATA_CLIP_SUCCESS";
export const UPDATE_METADATA_CLIP_FAIL = "UPDATE_METADATA_CLIP_FAIL";
export const UPDATE_METADATA_PROJECT_START = "UPDATE_METADATA_PROJECT_START";
export const UPDATE_METADATA_PROJECT_SUCCESS = "UPDATE_METADATA_PROJECT_SUCCESS";
export const UPDATE_METADATA_PROJECT_FAIL = "UPDATE_METADATA_PROJECT_FAIL";
export const UPDATE_METADATA_DISTRIBUTION_START = "UPDATE_METADATA_DISTRIBUTION_START";
export const UPDATE_METADATA_DISTRIBUTION_SUCCESS = "UPDATE_METADATA_DISTRIBUTION_SUCCESS";
export const UPDATE_METADATA_DISTRIBUTION_FAIL = "UPDATE_METADATA_DISTRIBUTION_FAIL";
export const ADD_MEMBER_PROJECT_START = "ADD_MEMBER_PROJECT_START";
export const ADD_MEMBER_PROJECT_SUCCESS = "ADD_MEMBER_PROJECT_SUCCESS";
export const ADD_MEMBER_PROJECT_FAIL = "ADD_MEMBER_PROJECT_FAIL";
export const DELETE_MEMBER_PROJECT_START = "DELETE_MEMBER_PROJECT_START";
export const DELETE_MEMBER_PROJECT_SUCCESS = "DELETE_MEMBER_PROJECT_SUCCESS";
export const DELETE_MEMBER_PROJECT_FAIL = "DELETE_MEMBER_PROJECT_FAIL";
export const UPDATE_METADATA_ROOM_START = "UPDATE_METADATA_ROOM_START";
export const UPDATE_METADATA_ROOM_SUCCESS = "UPDATE_METADATA_ROOM_SUCCESS";
export const UPDATE_METADATA_ROOM_FAIL = "UPDATE_METADATA_ROOM_FAIL";
export const LOAD_METADATA_CONFIG_START = "LOAD_METADATA_CONFIG_START";
export const LOAD_METADATA_CONFIG_SUCCESS = "LOAD_METADATA_CONFIG_SUCCESS";
export const LOAD_METADATA_CONFIG_FAIL = "LOAD_METADATA_CONFIG_FAIL";
export const METADATA_LOADING = "METADATA_LOADING";
export const LOAD_SOAP_API_DEF_START = "LOAD_SOAP_API_DEF_START";
export const LOAD_SOAP_API_DEF_SUCCESS = "LOAD_SOAP_API_DEF_SUCCESS";
export const LOAD_SOAP_API_DEF_FAIL = "LOAD_SOAP_API_DEF_FAIL";
export const SAVE_METADATA_CONFIG_START = "SAVE_METADATA_CONFIG_START";
export const SAVE_METADATA_CONFIG_SUCCESS = "SAVE_METADATA_CONFIG_SUCCESS";
export const SAVE_METADATA_CONFIG_FAIL = "SAVE_METADATA_CONFIG_FAIL";
export const UPDATE_METADATA_CONFIG = "UPDATE_METADATA_CONFIG";
export const METADATA_CONDITIONAL_FAIL = "METADATA_CONDITIONAL_FAIL";
export const METADATA_CONDITIONAL_RESET = "METADATA_CONDITIONAL_RESET";

//Cart types
export const ADD_SELECTED_TO_CART = "ADD_SELECTED_TO_CART";
export const EMPTY_CART = "EMPTY_CART";
export const ADD_CLIP_TO_CART = "ADD_CLIP_TO_CART";
export const REMOVE_CLIP_FROM_CART = "REMOVE_CLIP_FROM_CART";
export const COPY_CART_START = "COPY_CART_START";
export const COPY_CART_SUCCESS = "COPY_CART_SUCCESS";
export const COPY_CART_FAIL = "COPY_CART_FAIL";

//mediafile types
export const DELETE_MEDIAFILE_START = "DELETE_MEDIAFILE_START";
export const DELETE_MEDIAFILE_SUCCESS = "DELETE_MEDIAFILE_SUCCESS";
export const DELETE_MEDIAFILE_FAIL = "DELETE_MEDIAFILE_FAIL";
export const EDIT_MEDIAFILE_START = "EDIT_MEDIAFILE_START";
export const EDIT_MEDIAFILE_FAIL = "EDIT_MEDIAFILE_FAIL";
export const EDIT_MEDIAFILE_SUCCESS = "EDIT_MEDIAFILE_SUCCESS";

//device types
export const DEVICE_LOAD_START = "DEVICE_LOAD_START";
export const DEVICE_LOAD_SUCCESS = "DEVICE_LOAD_SUCCESS";
export const DEVICE_LOAD_FAIL = "DEVICE_LOAD_FAIL";
export const DEVICE_SET_SEARCH = "DEVICE_SET_SEARCH";

//vimeo types
export const VIMEO_LOAD_START = "VIMEO_LOAD_START";
export const VIMEO_LOAD_SUCCESS = "VIMEO_LOAD_SUCCESS";
export const VIMEO_LOAD_FAIL = "VIMEO_LOAD_FAIL";
export const VIMEO_UPLOAD_START = "VIMEO_UPLOAD_START";
export const VIMEO_UPLOAD_SUCCESS = "VIMEO_UPLOAD_SUCCESS";
export const VIMEO_UPLOAD_FAIL = "VIMEO_UPLOAD_FAIL";
export const VIMEO_DELETE_START = "VIMEO_DELETE_START";
export const VIMEO_DELETE_SUCCESS = "VIMEO_DELETE_SUCCESS";
export const VIMEO_DELETE_FAIL = "VIMEO_DELETE_FAIL";
export const VIMEO_SET_CURRENT_VIDEO = "VIMEO_SET_CURRENT_VIDEO";
//export const DEVICE_SET_SEARCH = "DEVICE_SET_SEARCH";

//comment types
export const DELETE_COMMENT_START = "DELETE_COMMENT_START";
export const DELETE_COMMENT_SUCCESS = "DELETE_COMMENT_SUCCESS";
export const DELETE_COMMENT_FAIL = "DELETE_COMMENT_FAIL";
export const GET_COMMENTS_START = "GET_COMMENTS_START";
export const GET_COMMENTS_SUCCESS = "GET_COMMENTS_SUCCESS";
export const GET_COMMENTS_FAIL = "GET_COMMENTS_FAIL";
export const ADD_COMMENT_START = "ADD_COMMENT_START";
export const ADD_COMMENT_SUCCESS = "ADD_COMMENT_SUCCESS";
export const ADD_COMMENT_FAIL = "ADD_COMMENT_FAIL";

//admin types
export const ADMIN_GET_USERS_START = "ADMIN_GET_USERS_START";
export const ADMIN_GET_USERS_SUCCESS = "ADMIN_GET_USERS_SUCCESS";
export const ADMIN_GET_USERS_FAIL = "ADMIN_GET_USERS_FAIL";

export const ADMIN_SAVE_USER_START = "ADMIN_SAVE_USER_START";
export const ADMIN_SAVE_USER_SUCCESS = "ADMIN_SAVE_USER_SUCCESS";
export const ADMIN_SAVE_USER_FAIL = "ADMIN_SAVE_USER_FAIL";
export const ADMIN_SAVE_NEW_USER_START = "ADMIN_SAVE_NEW_USER_START";
export const ADMIN_SAVE_NEW_USER_SUCCESS = "ADMIN_SAVE_NEW_USER_SUCCESS";
export const ADMIN_SAVE_NEW_USER_FAIL = "ADMIN_SAVE_NEW_USER_FAIL";
export const ADMIN_SET_GRANTING = "ADMIN_SET_GRANTING";
export const ADMIN_GET_ALL_GRANTS_FAIL = "ADMIN_GET_ALL_GRANTS_FAIL";
export const ADMIN_GET_ALL_GRANTS_START = "ADMIN_GET_ALL_GRANTS_START";
export const ADMIN_SET_ALL_GRANTS = "ADMIN_SET_ALL_GRANTS";
export const ADMIN_DELETE_USER_START = "ADMIN_DELETE_USER_START";
export const ADMIN_DELETE_USER_SUCCESS = "ADMIN_DELETE_USER_SUCCESS";
export const ADMIN_DELETE_USER_FAIL = "ADMIN_DELETE_USER_FAIL";
export const ADMIN_SET_EDITUSER = "ADMIN_SET_EDITUSER";
export const ADMIN_LOAD_USER_SETTING_START = "ADMIN_LOAD_USER_SETTING_START";
export const ADMIN_LOAD_USER_SETTING_SUCCESS = "ADMIN_LOAD_USER_SETTING_SUCCESS";
export const ADMIN_LOAD_USER_SETTING_FAIL = "ADMIN_LOAD_USER_SETTING_FAIL";
export const ADMIN_SAVE_USER_SETTING_START = "ADMIN_SAVE_USER_SETTING_START";
export const ADMIN_SAVE_USER_SETTING_SUCCESS = "ADMIN_SAVE_USER_SETTING_SUCCESS";
export const ADMIN_SAVE_USER_SETTING_FAIL = "ADMIN_SAVE_USER_SETTING_FAIL";

//user types
export const USER_GET_USERS_START = "USER_GET_USERS_START";
export const USER_GET_USERS_SUCCESS = "USER_GET_USERS_SUCCESS";
export const USER_GET_USERS_FAIL = "USER_GET_USERS_FAIL";

// Notification types
export const NOTIFICATION_LOAD_START = "NOTIFICATION_LOAD_START";
export const NOTIFICATION_LOAD_SUCCESS = "NOTIFICATION_LOAD_SUCCESS";
export const NOTIFICATION_LOAD_FAIL = "NOTIFICATION_LOAD_FAIL";

export const NOTIFICATION_SEARCH_START = "NOTIFICATION_SEARCH_START";
export const NOTIFICATION_SEARCH_SUCCESS = "NOTIFICATION_SEARCH_SUCCESS";
export const NOTIFICATION_SEARCH_FAIL = "NOTIFICATION_SEARCH_FAIL";

export const NOTIFICATION_ADD_START = "NOTIFICATION_ADD_START";
export const NOTIFICATION_ADD_SUCCESS = "NOTIFICATION_ADD_SUCCESS";
export const NOTIFICATION_ADD_FAIL = "NOTIFICATION_ADD_FAIL";

export const NOTIFICATION_SET_START = "NOTIFICATION_SET_START";
export const NOTIFICATION_SET_SUCCESS = "NOTIFICATION_SET_SUCCESS";
export const NOTIFICATION_SET_FAIL = "NOTIFICATION_SET_FAIL";

// Notification approcval users
export const NOTIFICATION_APPROVAL_USER_START = "NOTIFICATION_APPROVAL_USER_START";
export const NOTIFICATION_APPROVAL_USER_SUCCESS = "NOTIFICATION_APPROVAL_USER_SUCCESS";
export const NOTIFICATION_APPROVAL_USER_FAIL = "NOTIFICATION_APPROVAL_USER_FAIL";

// Notification sender user
export const NOTIFICATION_SENDER_USER_START = "NOTIFICATION_SENDER_USER_START";
export const NOTIFICATION_SENDER_USER_SUCCESS = "NOTIFICATION_SENDER_USER_SUCCESS";
export const NOTIFICATION_SENDER_USER_FAIL = "NOTIFICATION_SENDER_USER_FAIL";

// workflows
export const WORKFLOW_SEND_START =  "WORKFLOW_SEND_START";
export const WORKFLOW_SEND_SUCCESS =  "WORKFLOW_SEND_SUCCESS";
export const WORKFLOW_SEND_FAIL =  "WORKFLOW_SEND_FAIL";

// france.tv contacts
export const FTV_CONTACTS_SEARCH_START = "FTV_CONTACTS_SEARCH_START";
export const FTV_CONTACTS_SEARCH_SUCCESS = "FTV_CONTACTS_SEARCH_SUCCESS";
export const FTV_CONTACTS_SEARCH_FAIL = "FTV_CONTACTS_SEARCH_FAIL";
export const FTV_CONTACT_CREATE_START = "FTV_CONTACT_CREATE_START";
export const FTV_CONTACT_CREATE_SUCCESS = "FTV_CONTACT_CREATE_SUCCESS";
export const FTV_CONTACT_CREATE_FAIL = "FTV_CONTACT_CREATE_FAIL";
export const FTV_CONTACT_EDIT_START = "FTV_CONTACT_EDIT_START";
export const FTV_CONTACT_EDIT_SUCCESS = "FTV_CONTACT_EDIT_SUCCESS";
export const FTV_CONTACT_EDIT_FAIL = "FTV_CONTACT_EDIT_FAIL";
export const FTV_CONTACT_DELETE_START = "FTV_CONTACT_DELETE_START";
export const FTV_CONTACT_DELETE_SUCCESS = "FTV_CONTACT_DELETE_SUCCESS";
export const FTV_CONTACT_DELETE_FAIL = "FTV_CONTACT_DELETE_FAIL";
export const FTV_GROUPS_SEARCH_START = "FTV_GROUPS_SEARCH_START";
export const FTV_GROUPS_SEARCH_SUCCESS = "FTV_GROUPS_SEARCH_SUCCESS";
export const FTV_GROUPS_SEARCH_FAIL = "FTV_GROUPS_SEARCH_FAIL";
export const FTV_GROUP_CREATE_START = "FTV_GROUP_CREATE_START";
export const FTV_GROUP_CREATE_SUCCESS = "FTV_GROUP_CREATE_SUCCESS";
export const FTV_GROUP_CREATE_FAIL = "FTV_GROUP_CREATE_FAIL";
export const FTV_GROUP_DELETE_START = "FTV_GROUP_DELETE_START";
export const FTV_GROUP_DELETE_SUCCESS = "FTV_GROUP_DELETE_SUCCESS";
export const FTV_GROUP_DELETE_FAIL = "FTV_GROUP_DELETE_FAIL";
export const FTV_GROUP_GET_START = "FTV_GROUP_GET_START";
export const FTV_GROUP_GET_SUCCESS = "FTV_GROUP_GET_SUCCESS";
export const FTV_GROUP_GET_FAIL = "FTV_GROUP_GET_FAIL";
export const FTV_GROUP_SAVE_START = "FTV_GROUP_SAVE_START";
export const FTV_GROUP_SAVE_SUCCESS = "FTV_GROUP_SAVE_SUCCESS";
export const FTV_GROUP_SAVE_FAIL = "FTV_GROUP_SAVE_FAIL";
export const FTV_GROUP_REMOVE_START = "FTV_GROUP_REMOVE_START";
export const FTV_GROUP_REMOVE_SUCCESS = "FTV_GROUP_REMOVE_SUCCESS";
export const FTV_GROUP_REMOVE_FAIL = "FTV_GROUP_REMOVE_FAIL";
export const FTV_GROUP_ADD_START = "FTV_GROUP_ADD_START";
export const FTV_GROUP_ADD_SUCCESS = "FTV_GROUP_ADD_SUCCESS";
export const FTV_GROUP_ADD_FAIL = "FTV_GROUP_ADD_FAIL";
export const FTV_CONTACTS_SET_ROOM = "FTV_CONTACTS_SET_ROOM";
